module.exports = __webpack_public_path__ + "idp-logo-29cd89f408a06c493b26.png";